import { Component, h, Prop } from '@stencil/core';
import { UuiInverseThemeProviderV1_3 } from './uui-inverse-theme-1_3';
import { UuiInverseThemeProviderV2_0 } from './uui-inverse-theme-2_0';
import { LATEST_THEME_VERSION } from './uui-theme';

const themeVersionToClassMap = {
  latest: UuiInverseThemeProviderV2_0,
  LATEST_THEME_VERSION: UuiInverseThemeProviderV2_0,
  '2.0': UuiInverseThemeProviderV2_0,
  '1.3': UuiInverseThemeProviderV1_3
};

@Component({
  tag: 'uui-inverse-theme',
  shadow: true
})
export class UuiInverseThemeProvider {
  @Prop() version = LATEST_THEME_VERSION;

  render() {
    const themeClass =
      themeVersionToClassMap[this.version] ?? themeVersionToClassMap['latest'];
    const css = themeClass['style'];
    return (
      <uui-theme-provider name="inverse" version={LATEST_THEME_VERSION}>
        <style>{css}</style>
      </uui-theme-provider>
    );
  }
}
